import React from 'react';
import { ListingPreferencesProps } from './types';

const ListingPreferences: React.FC<ListingPreferencesProps> = ({
  preferences,
  onPreferenceChange,
  isEditing = false
}) => {
  return (
    <div className="mt-8">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Listing Preferences
      </h2>

      <p className="text-gray-600 mb-4 text-sm md:text-base">
        Choose what contact information to display on your property listings.
      </p>

      <div className="space-y-3">
        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={preferences.showEmail}
            onChange={() => onPreferenceChange('showEmail')}
            disabled={!isEditing}
            className="form-checkbox h-5 w-5 md:h-6 md:w-6 text-blue-600"
          />
          <span className="text-gray-700 text-sm md:text-base">
            Show email on property listings
          </span>
        </label>

        <label className="flex items-center space-x-3">
          <input
            type="checkbox"
            checked={preferences.showMobile}
            onChange={() => onPreferenceChange('showMobile')}
            disabled={!isEditing}
            className="form-checkbox h-5 w-5 md:h-6 md:w-6 text-blue-600"
          />
          <span className="text-gray-700 text-sm md:text-base">
            Show mobile number on property listings
          </span>
        </label>
      </div>
    </div>
  );
};

export default ListingPreferences;
